export const hongbao = {
    hb: "Angpao",
    dps: "Bagi-bagi besar",
    xdhb: "Angpao terbatas, hadiah jutaan rupiah menantimu",
    fxhb: "Bagikan angpao untuk mendapatkan lebih banyak hadiah",
    khb: "Buka Angpao",
    kqz: "Membuka...",
    ylq: "Telah diambil",
    hdwks: "Acara belum dimulai",
    hdjxz: "Acara sedang berlangsung",
    hdyjs: "Acara telah berakhir",
    hddjs: "Hitungan mundur acara",
    hdsj: "Waktu acara",
    zwhd: "Belum ada acara",
    hblsjlxq: "Riwayat hadiah angpao saya",
    jxz: "Sedang Berlangsung",
    ygq: "Kedaluwarsa",
    dks: "Segera dimulai",
    zwjl: "Belum ada hadiah",
    wnmztj: "Anda belum memenuhi syarat acara",
    wxts: "Pengingat",
    yhwcrz: "Pengguna telah menyelesaikan verifikasi KYC dan mengikat nomor ponsel",
    yhwcjy: "Pengguna telah memenuhi salah satu syarat: trading spot ≥100 USDT ATAU trading kontrak (tanpa leverage) ≥100 USDT ATAU trading opsi ≥100 USDT ATAU trading GameFi ≥100 USDT",
    djzh: "Akun yang dikendalikan risiko atau dibatasi penarikan tidak dapat mengikuti acara.",
    hdhbjl: "Hadiah Diterima",
    sqbj: "Kurang beruntung",
    dkapp: "Buka aplikasi",
    smewm: "Pindai kode QR",
    wchdtj: "Penuhi syarat acara untuk mengambil angpao",
    fxhd: "Bagikan acara untuk mendapat lebih banyak angpao",
    jdcz: "Langkah mudah, dapatkan keuntungan",
    hdhb: "Angpao Acara",
    zdqj: "Periode yang Ditentukan",
    wcjye: "Selesaikan volume perdagangan {type} {text} ≥ {amount} USDT",
    yhwfhtj: "Dalam {time} sebelum angpao diluncurkan, pengguna tidak memiliki transaksi yang memenuhi syarat",
    hbsxq: "Dalam {time}{day} sebelum angpao diluncurkan, pengguna {text}",
    bhgg: "Tidak termasuk leverage",
    h: " atau ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/ba.js